import { render, staticRenderFns } from "./SendDetail.vue?vue&type=template&id=d12dd112&scoped=true&"
import script from "./SendDetail.vue?vue&type=script&lang=js&"
export * from "./SendDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12dd112",
  null
  
)

export default component.exports